"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectCalendar = void 0;
const ac_1 = require("@app/ac");
const ui_1 = require("@app/component/ui");
const const_1 = require("@app/const");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const clipboard_1 = __importDefault(require("@app/util/clipboard"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const ConnectCalendar = () => {
    const [type, setType] = react_1.default.useState('google');
    const [onlyMyShifts, setOnlyMyShifts] = react_1.default.useState(true);
    const dispatch = (0, store_1.useRootDispatch)();
    const exportToken = (0, store_1.useRootSelector)((state) => state.exportToken);
    const userId = (0, store_1.useRootSelector)((state) => state.me).id;
    const { canRead } = (0, util_1.useAccessRole)();
    const hasAccessToManagerCalendar = canRead(const_1.PERMISSIONS.CALENDAR);
    const handleSubmit = async () => {
        const st = (0, moment_1.default)().startOf('month').format('YYYY-MM-DD');
        const en = (0, moment_1.default)().add(1, 'month').endOf('month').format('YYYY-MM-DD');
        const res = await dispatch((0, ac_1.loadExportToken)('ical', st, en, type, onlyMyShifts ? userId : undefined));
        if ((0, util_1.isUndefined)(res)) {
            return;
        }
        if (type === 'google') {
            window.open(res.googleImportUrl, '_blank');
        }
        if (type === 'ical') {
            window.open(res.url, '_blank');
        }
    };
    return (react_1.default.createElement(ui_1.Modal, { size: ui_1.Modal.SIZES.S, headerContent: react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
            react_1.default.createElement(ui_1.Text, { text: (0, util_1.t)('ACC_SET_CONNECT'), type: ui_1.Text.TYPES.BODY_LARGE, weight: ui_1.Text.WEIGHTS.BOLD })), footerContent: react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'end', width: '100%' } },
            react_1.default.createElement(ui_1.Button, { onClick: () => {
                    void dispatch((0, ac_1.setModal)(null));
                } }, (0, util_1.t)('CLOSE')),
            react_1.default.createElement(ui_1.Button, { style: 'CONTAINED', onClick: handleSubmit }, (0, util_1.t)('EXPORT_SUBMIT'))) },
        react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_16, type: ui_1.Spacing.TYPES.BOTH },
            react_1.default.createElement(ui_1.Flex, { direction: ui_1.Flex.DIRECTION.COLUMN },
                react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_MEDIUM, weight: ui_1.Text.WEIGHTS.BOLD, text: (0, util_1.t)('EXPORT_CALS_TYPE') }),
                react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_12 }),
                react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '0.5rem' } },
                    react_1.default.createElement(ui_1.Radio, { onClick: () => setType('google'), value: type === 'google' }, (0, util_1.t)('EXPORT_CALS_TYPE1')),
                    react_1.default.createElement(ui_1.Radio, { value: type === 'ical', label: (0, util_1.t)('EXPORT_CALS_TYPE2'), onClick: () => setType('ical') }),
                    react_1.default.createElement(ui_1.Radio, { value: type === 'other', onClick: async () => {
                            setType('other');
                            if (!exportToken?.icsUrl) {
                                await dispatch((0, ac_1.loadExportToken)('ical'));
                            }
                        }, label: (0, util_1.t)('EXPORT_CALS_TYPE3') }))),
            react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_12 }),
            type === 'other' && exportToken?.icsUrl && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_8 }),
                (0, util_1.t)('ACC_SET_CALENDAR_URL'),
                react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_8 }),
                react_1.default.createElement(ui_1.Link, { type: ui_1.Link.TYPES.ON_CLICK, onClick: () => clipboard_1.default.copy(exportToken?.icsUrl) },
                    react_1.default.createElement(ui_1.Flex, { align: ui_1.Flex.POSITION.CENTER },
                        react_1.default.createElement(ui_1.Icon, { ico: ui_1.Icon.ICONS.link }),
                        react_1.default.createElement("div", { style: { lineBreak: 'anywhere', marginLeft: '0.5rem' } },
                            react_1.default.createElement(ui_1.Text, { weight: ui_1.Text.WEIGHTS.BOLD, type: ui_1.Text.TYPES.BODY_MEDIUM, text: exportToken?.icsUrl })))))),
            hasAccessToManagerCalendar ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { style: {
                        margin: '0.8rem 0',
                        borderBottom: 'solid 1px #d9e3ff',
                    } }),
                react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '0.5rem' } },
                    react_1.default.createElement(ui_1.Radio, { onClick: () => setOnlyMyShifts(true), value: onlyMyShifts }, (0, util_1.t)('EXPORT_CALS_ONLY_MY_SHIFTS_TRUE')),
                    react_1.default.createElement(ui_1.Radio, { onClick: () => setOnlyMyShifts(false), value: !onlyMyShifts }, (0, util_1.t)('EXPORT_CALS_ONLY_MY_SHIFTS_FALSE'))),
                react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_8 }))) : null,
            react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_12 }))));
};
exports.ConnectCalendar = ConnectCalendar;
